import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { observer, useObserver } from 'mobx-react-lite';
import Moment from 'react-moment';

/* packages */
import { ModuleWrapperMain, ModuleWrapperMd } from '../../lib-atomic-design-section';
/* packages */

/* modules */
import CompanyNav from '../nav/company';
import CompanyTitle from '../title/company';
import CompanyList from './list';
import CompanySearch from '../../app-module-company-search-button/default';
/* modules */

const index = observer((props) => {

  return <ModuleWrapperMain>
    <ModuleWrapperMd>
    <CompanyNav {...props} />
    <CompanyTitle {...props} />
    <CompanySearch {...props} />
    <CompanyList {...props} />
    </ModuleWrapperMd>
  </ModuleWrapperMain>

});

export default index;
